import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { ProductModule } from '@erp/shared-types';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
} from '../../route';

// Legacy sales order detail, moved here from /sales-orders/$salesOrderId when
// OMS v3 took over the unversioned path. The component intentionally stays in
// ../../sales-orders/$salesOrderId/ (folder not renamed to avoid churn).
const SalesOrderPage = lazyRouteComponent(
  () => import('../../sales-orders/$salesOrderId/SalesOrderPage'),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/sales-orders-v2/$salesOrderId',
  component: SalesOrderPage,
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
});
